import isURL from 'validator/lib/isURL';

const urlOptions = {
  allow_protocol_relative_urls: false,
  allow_trailing_dot: false,
  allow_underscores: false,
  protocols: ['https'],
  require_host: true,
  require_protocol: true,
  require_tld: false,
  require_valid_protocol: true,
};

export const isValidUrl = (value: string) => isURL(value, urlOptions);
